import { OnInit, Component, Inject } from '@angular/core';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PatientView } from '../../../model/patient/patient-view';
import { PatientService } from '../../../services/patient.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'patient-view-dialog',
  templateUrl: 'patient-view-dialog.component.html',
  styleUrls: ['./patient-view-dialog.component.css']
})
export class PatientViewDialogComponent implements OnInit {

  patient: PatientView;

  constructor(private notificationToastService: NotificationToastService
    , private patientService: PatientService
    , public dialogRef: MatDialogRef<PatientViewDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async ngOnInit() {
    this.patient = await this.patientService.getPatientView(this.data.patientId);
  }
}
